import { Component, Host, h, Prop } from '@stencil/core';

@Component({
	tag: 'loading-indicator',
	styleUrl: 'loading-indicator.scss',
	shadow: true,
})
export class LoadingIndicator {
	@Prop() text: string = 'Loading...';
	render() {
		return (
			<Host>
				<div aria-live="assertive" class="data-loading">
					<span class="indicator">{this.text}</span>
					<slot></slot>
				</div>
			</Host>
		);
	}
}
